class AboutTeam extends HTMLElement {
  connectedCallback() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init(), {
        once: true,
      });
    } else {
      this.init();
    }
  }

  init() {
    if (this.initialised) return;

    const dataEl = this.querySelector("[data-team-data]");
    if (!dataEl) return;

    try {
      this.members = JSON.parse(dataEl.textContent);
    } catch (e) {
      this.members = [];
    }
    if (!this.members.length) return;

    this.flyout = this.querySelector("[data-team-flyout]");
    this.panel = this.querySelector("[data-team-flyout-panel]");
    this.imageEl = this.querySelector("[data-team-flyout-image]");
    this.positionEl = this.querySelector("[data-team-flyout-position]");
    this.nameEl = this.querySelector("[data-team-flyout-name]");
    this.bioEl = this.querySelector("[data-team-flyout-bio]");
    this.closeEl = this.querySelector("[data-team-flyout-close]");
    this.overlayEl = this.querySelector("[data-team-flyout-overlay]");
    if (!this.flyout || !this.panel) return;

    this.currentIndex = -1;
    this.lastTrigger = null;

    this.onKeydown = this.onKeydown.bind(this);

    this.desktopQuery = window.matchMedia("(min-width: 768px)");

    this.querySelectorAll("[data-team-trigger]").forEach((trigger) => {
      trigger.addEventListener("click", () => {
        if (!this.desktopQuery.matches) return;
        this.open(Number(trigger.dataset.teamTrigger), trigger);
      });
    });

    this.querySelectorAll("[data-team-flyout-prev]").forEach((btn) => {
      btn.addEventListener("click", () => this.step(-1));
    });
    this.querySelectorAll("[data-team-flyout-next]").forEach((btn) => {
      btn.addEventListener("click", () => this.step(1));
    });

    this.closeEl.addEventListener("click", () => this.close());
    this.overlayEl.addEventListener("click", () => this.close());

    this.initialised = true;
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.onKeydown);
    document.body.classList.remove("overflow-hidden");
  }

  render(index) {
    const member = this.members[index];
    if (!member) return;

    this.currentIndex = index;

    if (member.image) {
      this.imageEl.src = member.image;
      this.imageEl.alt = member.alt || member.name || "";
      this.imageEl.hidden = false;
    } else {
      this.imageEl.removeAttribute("src");
      this.imageEl.hidden = true;
    }

    this.positionEl.textContent = member.position || "";
    this.positionEl.hidden = !member.position;
    this.nameEl.textContent = member.name || "";
    this.bioEl.textContent = member.description || "";

    const single = this.members.length < 2;
    this.querySelectorAll(
      "[data-team-flyout-prev], [data-team-flyout-next]"
    ).forEach((btn) => {
      btn.disabled = single;
    });
  }

  step(delta) {
    if (this.members.length < 2) return;
    const next =
      (this.currentIndex + delta + this.members.length) % this.members.length;
    this.render(next);
    this.panel.scrollTop = 0;
  }

  open(index, trigger) {
    this.lastTrigger = trigger || null;
    this.render(index);

    this.flyout.dataset.open = "true";
    this.panel.dataset.open = "true";
    this.flyout.setAttribute("aria-hidden", "false");
    document.body.classList.add("overflow-hidden");
    document.addEventListener("keydown", this.onKeydown);

    this.panel.scrollTop = 0;
    this.closeEl.focus({ preventScroll: true });
  }

  close() {
    this.flyout.dataset.open = "false";
    this.panel.dataset.open = "false";
    this.flyout.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow-hidden");
    document.removeEventListener("keydown", this.onKeydown);

    if (this.lastTrigger) this.lastTrigger.focus({ preventScroll: true });
  }

  onKeydown(event) {
    if (event.key === "Escape") {
      this.close();
      return;
    }
    if (event.key === "ArrowLeft") this.step(-1);
    if (event.key === "ArrowRight") this.step(1);
  }
}

customElements.define("about-team", AboutTeam);
